import React, { useEffect,useState,useRef } from "react";
import axios from 'axios';
import swal from "sweetalert";
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import PhoneImg from '../../../local-assets/membership/half-phone-img.png';
import GoldIcon from '../../../local-assets/membership/gold-icon.png';
import GreenIcon from '../../../local-assets/membership/green-icon.png';
import CircleGray from "../../../local-assets/membership/bg-circle-gray.png";
import Footer from '../../../local-assets/membership/stamp-footer.png';

const StampType = () => {
  return (
    <section className="bg-[#F8F9FA] pb-6 pt-6 md:pt-10 md:pb-10 overflow-hidden relative">
      <div 
        className="absolute inset-0 pointer-events-none bg-no-repeat bg-bottom bg-[length:150%] md:bg-[length:70%] opacity-50"
        style={{ 
          backgroundImage: `url(${CircleGray})`,
          zIndex:99
        }}
      ></div>
      <img 
        src={Footer}
        alt="dekorasi bawah" 
        style={{zIndex:99}}
        className="absolute bottom-0 left-0 w-full h-auto object-cover pointer-events-none z-0" 
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <nav className="flex items-center gap-2 md:gap-3 text-sm md:text-base font-medium text-[#475467] py-4 mb-5">
          <Link to="/" className="hover:text-[#F36F21] transition-colors flex items-center">
            <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
            </svg>
          </Link>
          <svg className="w-4 h-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
          </svg>
          <span className="transition-colors font-semibold">
            Membership
          </span>
        </nav>

        <div className="mb-16 text-left">
          <h3 className="text-2xl md:text-3xl font-bold text-[#101828] mb-4">Penjelasan Stamp</h3>
          <p className="text-[#475467] text-base md:text-lg">
            Nikmati akses eksklusif ke berbagai keuntungan dan fasilitas khusus. Register sekarang dan nikmati reward dari kami.
          </p>
        </div>

        <div className="text-center mb-10 md:mb-16">
          <h3 className="text-2xl md:text-3xl font-bold text-[#101828]">
            Ada 2 jenis stamp yang dapat kamu kumpulkan
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-center relative z-20">
          
          <div className="order-1 md:order-1 flex justify-center md:justify-end">
            {/* Tambahkan flex-row untuk HP, dan md:flex-col untuk Desktop */}
            <div className="bg-white border border-gray-200 rounded-2xl p-4 md:p-6 w-full text-left shadow-sm relative z-10 flex flex-row md:flex-col items-center md:items-start gap-4 md:gap-0">
              
              {/* flex-shrink-0 memastikan ikon tidak gepeng/mengecil jika teksnya panjang */}
              <img src={GoldIcon} alt="gold" className="h-10 md:h-12 md:mb-5 object-contain flex-shrink-0" />
              
              {/* Bungkus teks dalam satu <div> */}
              <div>
                <h4 className="font-bold text-base md:text-lg text-[#101828] mb-1 md:mb-2">Premium Stamp</h4>
                <p className="text-xs md:text-sm text-[#475467] leading-relaxed">
                  Premium hanya dapat dikumpulkan oleh{' '}
                  {/* Sembunyikan <br> di HP agar teks mengalir natural, tampilkan lagi di Desktop */}
                  <br className="hidden md:block" />
                  <span className="font-semibold text-[#101828]">Gold Member</span>
                </p>
              </div>

            </div>
          </div>

          <div className="order-2 md:order-3 flex justify-center md:justify-start">
            <div className="bg-white border border-gray-200 rounded-2xl p-4 md:p-6 w-full text-left shadow-sm relative z-10 flex flex-row md:flex-col items-center md:items-start gap-4 md:gap-0">
              
              <img src={GreenIcon} alt="green" className="h-10 md:h-12 md:mb-5 object-contain flex-shrink-0" />
              
              <div>
                <h4 className="font-bold text-base md:text-lg text-[#101828] mb-1 md:mb-2">Regular Stamp</h4>
                <p className="text-xs md:text-sm text-[#475467] leading-relaxed">
                  Regular stamp dapat dikumpulkan oleh{' '}
                  <br className="hidden md:block" />
                  <span className="font-semibold text-[#101828]">Green & Gold Member</span>
                </p>
              </div>

            </div>
          </div>
          
          <div className="order-3 md:order-2 flex justify-center mt-6 md:mt-0 relative z-20">
            <img src={PhoneImg} alt="phone" className="h-[350px] md:h-[420px] w-auto object-contain drop-shadow-xl" />
          </div>

        </div>
      </div>
    </section>
  );
};
  
export default StampType;
